import styled from 'styled-components';
import deloitteLogo from '../../assets/brandLogo/deloitte-logo.png';
import { useAuthContext } from '../../contexts/AuthContext';
import { Avatar } from '../Global/Atomics/Avatar';
import { SearchBar } from '../Global/Atomics/SearchBar';
import CustomIcon from '../Global/Icons/CustomIcon';
import { useState } from 'react';
import { Dropdown, Tooltip } from 'antd';
// import { useLanguageContext } from '../../contexts/LanguageContext';
import { useContentContext } from '../../contexts/ContentContext';

const StyledHeader = styled.header`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    position: relative;
    min-height: 10vh;
    max-width: inherit;
    border: 1px solid #DCE3E5;
`;

const Image = styled.img`
    height: 1,5em;
    margin: 5px 0px 0px 77px;
`;


const Initials = styled.div`
    position: absolute;
    left: 17.5%;
    right: 17.5%;
    top: 25%;
    bottom: 25%;

    /* UI/XL medium */

    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    /* identical to box height, or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    /* Secondary/Blue/Blue 5 */

    color: #005587;
`;

const IconDropdown = styled.div`
    :hover{
        cursor: pointer;
    }
`;

export const Header = () => {
    const [activeId, setActiveId] = useState(0);
    const { changePage } = useContentContext();
    // const { currentLanguage } = useLanguageContext();
    // const context = useContext(LanguageContext);
    // const i18n = context[currentLanguage];

    const headerData = [
        {
            title: "Videowall",
            link: "/videowall",
            componentId: 'videowall'
        },
        {
            title: "Configurations",
            link: "/configurations",
            componentId: "configurations"
        },
        {
            title: "Guide",
            link: "/guide",
            componentId: "guide"
        }
    ];

    return (
        <StyledHeader>
            <div style={{display: 'flex', alignItems: 'center', height: '10vh'}}>
                <Image src={deloitteLogo} alt='deloitte logo'/>
                <div style={{marginLeft: '104px', height: '100%', display: 'flex', alignItems: 'center'}}>
                    <ul style={{width: 'max-content', height: '100%', display: 'flex', alignItems: 'center'}}>
                        {headerData.map((val, key) => {
                            return(<li key={key} 
                                style={{display: 'flex', marginRight: '64px', fontFamily: 'Inter', height: '100%', alignItems: 'center', color: '#63666A'}}
                                onClick={() => {setActiveId(key); changePage(val.componentId)}}
                                className={activeId === key ? "menuListActive" : ''}
                                >{val.title}</li>)
                            })}
                    </ul>
                </div>
            </div>
            <div style={{marginRight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '534px', height: '10vh'}}>
                <div style={{width: '310px'}}>
                    <SearchBar />
                </div>
                <div style={{ width: '104px', display: 'flex', justifyContent: 'space-around'}}>
                    <GlobalDropdown />
                    <HelpDropdown />
                    {/* <CustomIcon icon={'Bell_md'} fill='#0076A8'/> */}
                </div>
                <AvatarInitals />
            </div>
        </StyledHeader>
    )
}

const GlobalDropdown = () =>{
    // const { changeLanguage, currentLanguage } = useLanguageContext();

    const items = [
        {
          label: 'j',//<p onClick={() => changeLanguage('en')} style={currentLanguage === 'en' ? {fontWeight: 'bold'} : null}>English</p>,
          key: '0',
        },
        {
          label: 'c',//<p onClick={() => changeLanguage('pt')} style={currentLanguage === 'pt' ? {fontWeight: 'bold'} : null}>Portugues</p>,
          key: '1',
        },
        // {
        //   label: <p onClick={() => changeLanguage('es')} style={currentLanguage === 'es' ? {fontWeight: 'bold'} : null}>Español</p>,
        //   key: '2',
        // },
        // {
        //   label: <p onClick={() => changeLanguage('ar')} style={currentLanguage === 'ar' ? {fontWeight: 'bold'} : null}>عربي</p>,
        //   key: '3',
        // }
    ];

    return(
        <Dropdown menu={{ items }} trigger={['click']}>
            <IconDropdown onClick={(e) => e.preventDefault()}><CustomIcon icon={'Global_md'} fill='#0076A8'/></IconDropdown>
        </Dropdown>
    )
}

const AvatarInitals = () => {
    const { userData, logout } = useAuthContext();

    const initials = userData?.username?.slice(0, 2) ?? 'sy';
    const items = [
        {
          label: <p onClick={() => logout()}>Logout</p>,
          key: '0',
        },
    ];

    return(
        // <Dropdown menu={{ items }} trigger={['click']}>
            <Avatar>
                <Initials>{initials.toUpperCase()}</Initials>
            </Avatar>
        // </Dropdown>
    )
}

const HelpDropdown = () => {
    // const { actualPage } = useContentContext();

    return(
        // <Tooltip placement="bottom" title={'Deloitte'} trigger='click'>
            <span><CustomIcon icon={'Help_md'} fill='#0076A8'/></span>
        // </Tooltip>
    )
}